// TH 05/01/2017 -- As of TS 2.2.1, typescript changed their typing of Object.create. It now always returns type any.
// This is a thin wrapper to give us the old behavior of infering the return type from the parameter type.
// Hopefully they'll roll out a bugfix, but in the meantime, this gives us a way to upgrade typescript.
// See AH's bug report: https://github.com/Microsoft/TypeScript/issues/14247
export default function objectCreate<T extends object>(obj : T) : T {
    return Object.create(obj);
}


// WEBPACK FOOTER //
// ./lib/objectCreate.ts